import './App.css';
import React, { Component } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'font-awesome/css/font-awesome.min.css';
import { createBrowserHistory } from 'history';
import { ConfigProvider } from 'antd';
import { basename } from './utils/constants';
import Auth from './components/Auth/Auth';
import {
    UserCenterLayoutRoutes,
    ProjectLayoutRoutes,
    TeachinLayoutRoutes,
    CompetitionLayoutRoutes,
    TenantRoutes,
    UsuallyRoutes,
    ExamAndPracticeLayoutRoutes,
    PlayerLayoutRoutes,
    OpenCourseLayoutRoutes,
    CommunityLayoutRoutes,
    GatewayRoutes,
    DeclarationLayoutRoutes,
    LoginLayoutRoutes,
    EvaluationLayoutRoutes,
    ChatAiLayoutRoutes,
    KnowLayoutRoutes,
    ListenCommentCourseLayoutRoutes,
    QuestionnaireLayoutRoutes,
    ActivityLayoutRoutes,
    AiCourseEvaluationLayoutRoutes,
    PublicInvitationLayoutRoutes,
    OnlineSeminarRoutes
} from './routes';
import { Navigate } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import NoMatch from './components/NoMatch';
import GrtLoading from './components/GrtLoading/GRTLoading';

import zhCN from 'antd/es/locale/zh_CN';
import utils from 'grt-tool-lib-front';
import { AiToolsRoutes } from '@/routes/AiTools';
import { EvaluationReportRoutes } from '@/routes/EvaluationReport';
import { fullBurialPoint, loginBurialPoint } from './utils/buryPoint';
import { Storage } from './utils/Storage';
import { TrainingPlanRoutes } from '@/routes/TrainingPlan';
import theme from '@/theme/themeColor.json';
import { setIsChangedTheme } from '@/utils/global';
import { obsDownloadFile } from '@/utils/obsService';
import { debuggerkey } from './utils/utils';
import 'dayjs/locale/zh-cn';
const history = createBrowserHistory();

@inject('store')
@observer
class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            canLoad: false,
            gatewayConfig: []
        };
    }

    async componentDidMount() {
        if (!Storage.get(debuggerkey) && process.env.REACT_APP_MODE === 'production') {
            window.console.log = () => {};
        }
        const {
            store: { login, global }
        } = this.props;
        utils.chineseDate(window.moment);
        if (window.location.pathname.includes('region_qhb_tenant') || window.location.pathname.includes('city_qhb_tenant')) {
            await login.getUserInfo();
        }
        if (
            /\/web\/public/.test(window.location.pathname) ||
            window.location.pathname.includes('auth-token-login') ||
            window.location.pathname.includes('wxWork-bind') ||
            window.location.pathname.includes('region_qhb_tenant') ||
            window.location.pathname.includes('city_qhb_tenant')
        ) {
            this.setState({
                canLoad: true
            });
            this.setThemeConfig();
            return;
        }
        global.getTenantConfig();
        let isHaveId = await login.getTenantInfo();
        if (window.location.search) {
            const params = new URLSearchParams(window.location.search),
                portal_id = params.get('source_id');
            if (portal_id) {
                localStorage.setItem('portal_id', portal_id);
            }
        }
        // try {
        //     //获取租户第三方配置
        //     await login.getThirdConfig();
        // } catch (error) {
        //     console.log(error);
        // }
        //如果是分享过来的查询一下门户类型 目前有智能体门户/普通租户门户

        await login.getUserInfo();
        await login.getAllHomePage();
        await login.getPageHeader();
        await login.getUserCenterRoutes();
        await login.getStudyRoutes();
        await this.setThemeConfig(login.allHomePage);
        // 获取路由配置
        await login.getHeaderRoutes();
        this.setState({ gatewayConfig: [] });
        if (isHaveId) {
            this.setState(
                {
                    canLoad: true
                },
                () => {
                    this.initFullPoint();
                    this.initLoginPoint();
                }
            );
        }
    }
    initFullPoint = async () => {
        const { login } = this.props.store;
        const isLogin = await login.checkLogin();
        let userInfoStr = Storage.get('userInfo');
        let data = {
            tenant_id: Storage.get('TENANT_KEY'),
            isLogin: isLogin
        };

        if (isLogin && userInfoStr) {
            let userInfo = JSON.parse(userInfoStr);
            data.uid = userInfo.id;
        }
        fullBurialPoint(data);
    };
    initLoginPoint = async () => {
        const { login } = this.props.store;
        const isLogin = await login.checkLogin();
        let userInfoStr = Storage.get('userInfo');
        let data = {
            tenant_id: Storage.get('TENANT_KEY'),
            isLogin: isLogin
        };

        if (isLogin && userInfoStr) {
            let userInfo = JSON.parse(userInfoStr);
            data.uid = userInfo.id;
            loginBurialPoint(data);
        }
    };

    setThemeConfig = async (allHomePage) => {
        let themeConfig = theme['blue'],
            themeType = 'blue';
        if (allHomePage && allHomePage.length) {
            allHomePage.forEach((v) => {
                if (v.alias === 'theme') {
                    if (v.page_config) {
                        let page_config = JSON.parse(v.page_config);
                        if (page_config.theme) {
                            themeConfig = theme[page_config.theme];
                            obsDownloadFile('function-attachment-upload', 'theme/common/themeColor.json').then((res) => {
                                if (res) themeConfig = res[page_config.theme];
                            });
                            themeType = page_config.theme;
                            setIsChangedTheme(true);
                        }
                    }
                }
            });
        }
        ConfigProvider.config({
            prefixCls: 'grt',
            // theme: themeConfig
            theme: {
                token:{
                colorPrimary:themeConfig.primaryColor,
                ...themeConfig
             }
            }
        });
        //受antd影响 强行覆盖antd自动生成的色值
        for (let key in themeConfig) {
            document.documentElement.style.setProperty('--grt-' + key, themeConfig[key]);
        }
        const {
            store: { global }
        } = this.props;
        await global.getThemeFromObsImg(themeType);
    };

    routerViews = (routes) => {
        const routerView = routes.map((item) => {
            const { key, ...rest } = item;
            return item.children && item.children.length ? (
                <Route key={key} path={item.path} element={<Auth {...rest}></Auth>}>
                    {[...this.routerViews(item.children)]}
                    {item.redirect ? (
                        <Route path={item.path} element={<Navigate to={item.redirect} />}></Route>
                    ) : (
                        <Route path={item.path} element={<Navigate to={item.children[0].path} />}></Route>
                    )}
                </Route>
            ) : (
                <Route key={key} path={item.path} element={<Auth key={key} {...rest}></Auth>}></Route>
            );
        });

        return routerView;
    };

    render() {
        return (
            <div className="App">
                {this.state.canLoad ? (
                    <BrowserRouter basename={basename} history={history}>
                        <ConfigProvider prefixCls="grt" locale={zhCN}>
                            {/* <Header></Header> */}
                            <Routes>
                                {this.routerViews(GatewayRoutes)}
                                {this.routerViews(UserCenterLayoutRoutes)}
                                {this.routerViews(ProjectLayoutRoutes)}
                                {this.routerViews(TeachinLayoutRoutes)}
                                {this.routerViews(CompetitionLayoutRoutes)}
                                {this.routerViews(TenantRoutes)}
                                {this.routerViews(UsuallyRoutes)}
                                {this.routerViews(ExamAndPracticeLayoutRoutes)}
                                {this.routerViews(PlayerLayoutRoutes)}
                                {this.routerViews(OpenCourseLayoutRoutes)}
                                {this.routerViews(DeclarationLayoutRoutes)}
                                {this.routerViews(CommunityLayoutRoutes)}
                                {this.routerViews(LoginLayoutRoutes)}
                                {this.routerViews(EvaluationLayoutRoutes)}
                                {this.routerViews(ChatAiLayoutRoutes)}
                                {this.routerViews(QuestionnaireLayoutRoutes)}
                                {this.routerViews(AiToolsRoutes)}
                                {this.routerViews(KnowLayoutRoutes)}
                                {this.routerViews(ListenCommentCourseLayoutRoutes)}
                                {this.routerViews(EvaluationReportRoutes)}
                                {this.routerViews(TrainingPlanRoutes)}
                                {this.routerViews(ActivityLayoutRoutes)}
                                {this.routerViews(AiCourseEvaluationLayoutRoutes)}
                                {this.routerViews(PublicInvitationLayoutRoutes)}
                                {this.routerViews(OnlineSeminarRoutes)}
                                <Route path="*" element={<NoMatch />} />
                            </Routes>
                        </ConfigProvider>
                    </BrowserRouter>
                ) : (
                    <GrtLoading></GrtLoading>
                )}
            </div>
        );
    }
}

export default App;
